<template>
	<div>
		<!-- <Cabecera></Cabecera> -->
		<main role="main">
	      <div class="c-steps-numbers">
	        <div class="container">
	          <div class="c-steps-numbers__item success"><span>1</span>
	            <p>Información y<br>antecedentes</p>
	          </div>
	          <div class="c-steps-numbers__item success"><span>2</span>
	            <p>Patrocinios</p>
	          </div>
	          <div class="c-steps-numbers__item active"><span>3</span>
	            <p>Declaraciones<br>y compromisos</p>
	          </div>
	        </div>
	      </div>
	      <div class="c-form-steps">
	      	<!-- <div class="requestNumber">
	      		<p>SOLICITUD N° {{globalRequestNumber}}</p>
	      	</div> -->
	        <div class="c-form-steps__sections" data-step="05">
	          <div class="container u-pt50">
	            <div class="c-form-steps__content step-data u-pt0">
	              <div class="row">
	                <div class="col-md-12 col-lg-8 offset-lg-2">
	                  <h2>Adhesión a compromisos y códigos de buenas prácticas</h2>
	                  <p>Lea y confirme cada uno de los compromisos obligatorios que los postulantes a socios  deben adquirir con la Cámara Chilena de la Construcción</p>
	                  <form action="#">
	                    <div class="form-tabs">
	                      <div :class="tab1" ref="tab1">
	                        <div class="tab-number">
	                          <p>1</p>
	                        </div>
	                        <div class="tab-info">
	                          <h3 tabindex="1">Código de Buenas Prácticas en la Industria de la Construcción</h3>
	                          <p>Este Código regula el comportamiento ético y las buenas prácticas de los socios de la Cámara Chilena de la Construcción, ya sea en sus relaciones o bien con terceros y es de carácter obligatorio.</p>
	                          <p>El postulante declara que toma conocimiento de lo antes señalado y se obliga al cumplimiento de las disposiciones contenidas en el Código y sus anexos.</p>
	                          <p>Conocer <a href="https://www.cchc.cl/uploads/basica/archivos/Descargar-Codigo-de-Buenas-Practicas-en-la-Industria-de-la-Construccion.pdf" target="_blank">aquí:</a></p>
	                          <div class="md-checkbox">
	                            <input id="tab01" type="checkbox"
	                            	@click="activeClass($refs.tab1), tabValidation()">
	                            <label for="tab01" id="checbox01">Acepto.</label>
	                          </div>
	                        </div>
	                      </div>
	                      <div :class="tab2" ref="tab2">
	                        <div class="tab-number">
	                          <p>2</p>
	                        </div>
	                        <div class="tab-info">
	                          <h3 tabindex="2">Declaración de Compromiso hacia Cero Accidentes Fatales</h3>
	                          <p>Declaro mi compromiso de trabajo permanente para alcanzar el objetivo de “Cero Accidentes Fatales” en la empresa que represento, ya referida, de acuerdo a los lineamientos y estrategias que, al efecto, implemente la Cámara Chilena de la Construcción A.G.</p>
	                          <p>Con el propósito de seguir construyendo una Cultura de Seguridad, mantendré integrada la Prevención de Riesgos en las operaciones habituales que ejecute la empresa a la cual represento, en todos sus centros de trabajo, comprometiéndome a establecer los más altos estándares de seguridad y salud laboral en todo nuestro quehacer y con todos los actores de la cadena de valor, a través de las siguientes conductas empresariales:</p>
	                          <ul>
	                            <li>Reconocer y gestionar la seguridad y la salud de todos nuestros trabajadores y de quienes participan de sus actividades como valor estratégico.</li>
	                            <li>Establecer una cultura de seguridad y salud en toda la organización, comenzando por los líderes, promoviendo la participación de nuestros trabajadores y fomentando la prevención.</li>
	                            <li>Anticipar los peligros inherentes en sus actividades, y analizar e implementar soluciones para eliminar o mitigar la exposición al riesgo.</li>
	                          </ul>
	                          <p>Lo anterior a través de las siguientes prácticas:<br>Definir y comunicar a la organización los objetivos en Seguridad y Salud en el trabajo, en adelante “SST”.<br>Identificar los peligros de SST e implementar un plan de mitigación asociados a ellos, con al menos una revisión anual.<br>Implementar un Sistema de Gestión en Seguridad y Salud en el Trabajo que involucre la participación de ejecutivos mandos medios y trabajadores.<br>Desarrollar un plan anual de capacitación en SST para ejecutivos, mandos medios y trabajadores.<br>Implementar un modelo de reporte de incidentes, realizando gestión sobre los hallazgos de riesgos mayores.<br>Reportar a la Comisión de Seguridad y Salud Laboral de la CChC los accidentes graves y/o fatales que se produzcan en la empresa y obras y afecten a trabajadores propios o de contratistas, facilitando información a la Comisión que permita realizar los aprendizajes de cada caso.</p>
	                          <div class="md-checkbox">
	                            <input id="tab02" type="checkbox"
	                            	@click="activeClass($refs.tab2), tabValidation()">
	                            <label for="tab02">Acepto y me comprometo</label>
	                          </div>
	                        </div>
	                      </div>
	                      <div :class="tab3" ref="tab3">
	                        <div class="tab-number">
	                          <p>3</p>
	                        </div>
	                        <div class="tab-info">
	                          <h3 tabindex="3">Declaración de Conocimiento del Modelo de Prevención de Delitos CChC</h3>
	                          <p>En cumplimiento de lo dispuesto en la Ley N° 20.393, la Cámara Chilena de la Construcción-CChC, ha adoptado e implementado un Modelo de Prevención de Delitos, que conforme a lo dispuesto en el Artículo 4°, N° 3, letra d), de dicha ley, entre otros elementos, debe incluir la existencia de obligaciones, prohibiciones, sanciones administrativas y procedimientos de denuncia y determinación de responsabilidades en contra de las personas que incumplan el modelo de prevención de delitos. Además, estas obligaciones, prohibiciones y sanciones deben ser incorporadas expresamente en los documentos que la CChC celebre con terceras partes, proveedores, socios y otros que considere necesario.<br>De esta manera, como postulante a socio de la CChC, declaro conocer y a su vez me obligo a cumplir con el Modelo de Prevención de Delitos (disponible en el sitio web www.CCHC.cl, en el Portal del Socio y entregado en este acto) implementado por la CChC, con el objeto de prevenir, evitar y detectar la comisión de los delitos de  Lavado de Activos, Financiamiento del Terrorismo, Cohecho Funcionario Público Nacional o Extranjero, Receptación, Negociación Incompatible, Corrupción entre Particulares, Apropiación Indebida, Administración Desleal, y los artículos 136, 139, 139 bis, 139 ter de la Ley General de Pesca y Acuicultura, como también en relación aquellos delitos que se incorporen en lo sucesivo en la Ley Nº20.393.</p>
	                          <div class="md-checkbox">
	                            <input id="tab03" type="checkbox"
	                            	@click="activeClass($refs.tab3), tabValidation()">
	                            <label for="tab03">Acepto y me comprometo</label>
	                          </div>
	                        </div>
	                      </div>
	                      
	                      <div :class="tab4" ref="tab4">
	                        <div class="tab-number">
	                          <p>4</p>
	                        </div>
	                        <div class="tab-info">
	                          <h3 tabindex="4">
	                          <p><strong>"Declaro que: 
									 No tengo trabajadores bajo vínculo de subordinación y dependencia, a los cuales extenderles los beneficios de los proyectos sociales de la Cámara Chilena de la Construcción. 
									 <p> 
									 No soy funcionario público ni ejerzo funciones en el sector público"</p>
									</strong></p></h3>
	                          <div class="md-checkbox">
	                            <input id="tab04" type="checkbox"
	                            	@click="activeClass($refs.tab4), tabValidation()">
	                            <label for="tab04">Acepto y me comprometo</label>
	                          </div>
	                        </div>
	                      </div>

	                      <!-- <div :class="tab5" ref="tab5">
	                        <div class="tab-number">
	                          <p>5</p>
	                        </div>
	                        <div :class="tabInfo" tabindex="5">

	                          <p><strong>"Declaro que: 
									 No tengo trabajadores bajo vínculo de subordinación y dependencia, a los cuales extenderles los beneficios de los proyectos sociales de la Cámara Chilena de la Construcción. 
									 <p> 
									 No soy funcionario público ni ejerzo funciones en el sector público"</p>
									</strong></p>
	                          <div class="md-checkbox">
	                            <input id="tab05" type="checkbox"
	                            	@click="activeClass($refs.tab5), tabValidation()">
	                            <label for="tab05">Acepto y me comprometo</label>
	                          </div>
	                        </div>
	                      </div> -->
	                    </div>
	                  </form>
	                </div>
	              </div>
	            </div>
	          </div>
			  
			<div class="c-form-drag whitebg small font" ref="motivationCollapse" style="background-color: #FFFFFF;" tabindex="8">
            <div class="container">
              <a class="section-minimizar pointer" ref="motivationMin" @click="collapseClick([$refs.motivationCollapse, $refs.motivationMin])">{{ collapse }}</a>
              <span tabindex="8" @keydown.tab="collapseTab([$refs.motivationCollapse, $refs.motivationMin])"></span>
              <div class="row">
                <div class="col-md-12 col-lg-6 offset-lg-2">
                  <h2 tabindex="6">MOTIVACIÓN PARA PERTENECER AL GREMIO</h2>
                  <p class="u-mb50">¿Cuál es tu motivación para pertenecer a este gremio?</p>
                    <form>
						<div class="input active">
                        <div class="input-select">
                          <select tabindex="6" ref="motivation01_st5" name="motivation01_st05"  style="font-size: 14px;" @input="$event = setMotivationOne($event.target.value)" :value="motivoSelectp1" :disabled="!this.corregir">
                            <option value="" hidden>Escoja la <strong>Primera Opción</strong></option>
                            <option
                              v-for="(motivo, key) in motivos"
                              :value="motivo.ID"
                              :key="key"
                              v-if="motivo.ID != 7"
                            >{{ motivo.GLOSA }}</option>
                            <option value="7">Otros</option>
                          </select>
                        </div>
                      </div>
                      <div class="input active" ref="otherp1_Confirmation" v-if="motivoSelectp1 == 7" >
                        <label>Especificar Otro como Primera Prioridad</label>
                        <input ref="other1" v-model="other1" @focus="focus($refs.otherp1_Confirmation)" @blur="blur([$refs.otherp1_Confirmation, $refs.other1.value])" type="text" :disabled="!this.corregir">
                      </div>
                      <div class="input active">
                        <div class="input-select">
                          <select style="font-size: 14px;" name="motivation02_st05" @input="$event = setMotivationTwo($event.target.value)" :value="motivoSelectp2"  :disabled="motivoSelectp1 === '' || !this.corregir">
                            <option value="" hidden>Escoja la <strong>Segunda Opción</strong></option>
                            <option
                              v-for="(motivo, key) in motivos"
                              :value="motivo.ID"
                              :key="key"
                              v-if="motivo.ID !== motivoSelectp1 && motivo.ID != 7"
                            >{{ motivo.GLOSA }}</option>
                            <option value="8">Otros</option>
                          </select>
                        </div>
                      </div>
                      <div class="input active" v-if="motivoSelectp2 == 8" ref="otherp2_Confirmation">
                        <label>Especificar Otro como Segunda Prioridad</label>
                        <input ref="otherp2_Value" v-model="other2" @focus="focus($refs.otherp2_Confirmation)" @blur="blur([$refs.otherp2_Confirmation, $refs.otherp2_Value.value])" type="text" :disabled="!this.corregir">
                      </div>
                      <div class="input">
                        <div class="input-select">
                          <select style="font-size: 14px;" name="motivation03_st05" @input="$event = setMotivationThree($event.target.value)" :value="motivoSelectp3"  :disabled="motivoSelectp2 === '' || !this.corregir">
                            <option value="" hidden>Escoja la <strong>Tercera Opción</strong></option>
                            <option
                              v-for="(motivo, key) in motivos"
                              :value="motivo.ID"
                              :key="key"
                              v-if="motivo.ID !== motivoSelectp1 && motivo.ID !== motivoSelectp2 && motivo.ID != 7"
                            >{{ motivo.GLOSA }}</option>
                            <option value="9">Otros</option>
                          </select>
                        </div>
                      </div>
                      <div class="input active" v-if="motivoSelectp3 == 9" ref="otherp3_Confirmation">
                        <label>Especificar Otro como Tercera Prioridad</label>
                        <input ref="otherp3_Value" v-model="other3" @focus="focus($refs.otherp3_Confirmation)" @blur="blur([$refs.otherp3_Confirmation, $refs.otherp3_Value.value])" type="text" :disabled="!this.corregir">
                      </div>
                  </form>                
                </div>
              </div>
            </div>
          </div>
	          <div class="c-form-steps whitebg">
	            <div class="container">
	              <div class="c-form-steps__content step-data">
	                <div class="row">
	                  <div class="col-lg-12 offset-lg-2">
	                    <form action="#" id="step04_3">
	                    	<button class="link prev btn-blue u-mt50 u-mr30 small" type="button"
	                    	@click="goSecondStep(), scrollToTop()">
	                    		<i class="fa fa-angle-left"></i>Anterior
	                    	</button>
							<div v-show="!tieneCorreccion" style="display: inline;">
								<button class="link btn-blue u-mt50 big u-mr20" 
									type="button" @click="saveThirdStep"
									tabindex="6" 
									:disabled="!this.corregir"
								>
									Guardar
								</button>

							</div>
	                    	
	                    	<button class="btn-grey link btn-red u-mt50 big" tabindex="7" type="button" 
		                       @click="ThirdStepValidation(), scrollToTop()" :disabled="!this.enviarActivo">
		                        ENVIAR POSTULACIÓN<i class="fa fa-angle-right"></i>
		                    </button>
	                    </form>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    </main>
	</div>
</template>

<script>
	import Cabecera from "@/components/Cabecera.vue";
	import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
	import axios from 'axios'
  	import VueAxios from 'vue-axios'
  	import Swal from 'sweetalert2'
	export default {
		name: "ThirdStep",
		components: {
			Cabecera,
		},
		data() {
			return {
				other1: "",
				other2: "",
				other3: "",
				motivoP1IsValid: true,
				motivoP2IsValid: true,
				motivoP3IsValid: true,
				otherP1IsValid: true,
				otherP2IsValid: true,
				otherP3IsValid: true,
				sendPostulation: '',
				tabCount: 0,
				thirdStepObject: [],
				success: '',
				corregir: true,
				tieneCorreccion: false,
				enviarActivo: true,
			}
		},

		methods: {
			...mapMutations(['focus', 'blur', 'collapseClick', 'rutValidation', 
				'phoneNumberValidation', 'emailValidation', 'saveCompletedFormPN', 'activeClass', 
				'setThirdStepValue', 'setSecondStepValue', 'setSuccessStepValue','setObjetoThirdStep','setFinalStatus', 'saveRequestNumber',
				'setCheck1', 'setCheck2', 'setCheck3', 'setCheck4', 'setCheck5', 'setCheck6', "setMotivationOne", "setMotivationTwo", "setMotivationThree"]),

			...mapGetters(['getterObjetoThirdStep', , 'getterMotivationOneP1', 'getterMotivationOneP2', 'getterMotivationOneP3']),

			...mapActions([
				"getMotivos"
			]),

			scrollToTop() {
		      window.scrollTo(0,0);
		    },

		    goSecondStep() {
		    	this.setSecondStepValue(true);
        		this.setThirdStepValue(false);
		    },

			motivationValidation(){
				let otherSelectP1 = this.motivoSelectp1;
				let otherSelectP2 = this.motivoSelectp2;
				let otherSelectP3 = this.motivoSelectp3;

				if(otherSelectP2 == otherSelectP1){
				otherSelectP2 = "";
				this.motivoSelectp2 = "";
				};
				if(otherSelectP3 == otherSelectP1){
				otherSelectP3 = "";
				this.motivoSelectp3 = "";
				};
				if(otherSelectP2 == otherSelectP3){
				otherSelectP3 = "";
				this.motivoSelectp3 = "";
				};

				if(otherSelectP1 == "7"){
				} else {
				this.other1 = "";
				};

				if(otherSelectP2 == "8"){
				} else {
				this.other2 = "";
				};

				if(otherSelectP3 == "9"){
				}else {
				this.other3 = "";
				};

				if (this.motivoSelectp1 == "" || this.motivoSelectp2 == "" || this.motivoSelectp3 == "" ) {
				this.motivoP1IsValid = false;
				this.motivoP2IsValid = false;
				this.motivoP3IsValid = false;
				this.sendPostulation = false;   
				Swal.fire({
					icon: 'warning',
					title: 'Debe seleccionar sus motivaciones antes de continuar.',
				})
					this.sendPostulation = false;
					this.enviarActivo = true;
				} else {
				this.motivoP1IsValid = true;
				this.motivoP2IsValid = true;
				this.motivoP3IsValid = true;      
				};

				if (this.motivoSelectp1 == 7 && this.other1 === ''){
				this.otherP1IsValid = false;
				this.sendPostulation = false;
				Swal.fire({
					icon: 'warning',
					title: 'Debe completar el campo Otros antes de continuar.',
				})
				this.sendPostulation = false;
				this.enviarActivo = true;
				} else {
				this.otherP1IsValid = true;
				};

				if (this.motivoSelectp2 == "8" && this.other2 === ''){
				this.otherP2IsValid = false;
				this.sendPostulation = false;
				Swal.fire({
					icon: 'warning',
					title: 'Debe completar el campo Otros antes de continuar.',
				})
				this.sendPostulation = false;
				this.enviarActivo = true;
				} else {
				this.otherP2IsValid = true;
				};
				
				if (this.motivoSelectp3 == "9" && this.other3 === ''){
				this.otherP3IsValid = false;
				this.sendPostulation = false;
				Swal.fire({
					icon: 'warning',
					title: 'Debe completar el campo Otros antes de continuar.',
				})
				this.sendPostulation = false;
				this.enviarActivo = true;
				} else {
				this.otherP3IsValid = true;
				};

				if (this.motivoSelectp3 == "7" && this.other1.trim().length == 0){
				this.otherP3IsValid = false;
				this.sendPostulation = false;
				Swal.fire({
					icon: 'warning',
					title: 'Debe completar el campo Otros antes de continuar.',
				})
				this.sendPostulation = false;
				this.enviarActivo = true;
				} else {
				this.otherP3IsValid = true;
				};

				if (this.motivoSelectp3 == "8" && this.other2.trim().length == 0){
				this.otherP3IsValid = false;
				this.sendPostulation = false;
				Swal.fire({
					icon: 'warning',
					title: 'Debe completar el campo Otros antes de continuar.',
				})
				this.sendPostulation = false;
				this.enviarActivo = true;
				} else {
				this.otherP3IsValid = true;
				};
				//console.log(this.other3.trim().length)
				if (this.motivoSelectp3 == "9" && this.other3.trim().length == 0){
				this.otherP3IsValid = false;
				this.sendPostulation = false;
				Swal.fire({
					icon: 'warning',
					title: 'Debe completar el campo Otros antes de continuar.',
				})
				this.sendPostulation = false;
				this.enviarActivo = true;
				} else {
				this.otherP3IsValid = true;
				};
			},

			tabValidation() {
				this.tabCount = this.tabCount + 1;
				//console.log("Count = " + this.tabCount);
			},

			ThirdStepValidation() {
				
				if(this.motivoSelectp1 == this.motivoSelectp2){
					this.motivoSelectp2 = "";
				};
				if(this.motivoSelectp1 == this.motivoSelectp3){
					this.motivoSelectp3 = "";
				};
				if(this.motivoSelectp2 == this.motivoSelectp3){
					this.motivoSelectp3 = "";
				};

				if(this.motivoSelectp1 == "7"){
				} else {
					this.other1 = "";
				};

				if(this.motivoSelectp2 == "8"){
				} else {
					this.other2 = "";
				};

				if(this.motivoSelectp3 == "9"){
				}else {
					this.other3 = "";
				};

		        if ((this.tabCount < 4) || ((this.motivoSelectp1 == this.motivoSelectp2) || (this.motivoSelectp1 == this.motivoSelectp3) || (this.motivoSelectp2 == this.motivoSelectp3)) || (this.motivoSelectp1 == "" || this.motivoSelectp2 == "" || this.motivoSelectp3 == "") || (this.motivoSelectp1 == 7 && this.other1 == '') || (this.motivoSelectp2 == 8 && this.other2 === '') || (this.motivoSelectp3 == 9 && this.other3 === '') || (this.motivoSelectp1 == "7" && this.other1.trim().length == 0) || (this.motivoSelectp2 == "8" && this.other2.trim().length == 0) || (this.motivoSelectp3 == "9" && this.other3.trim().length == 0)){
		          this.sendPostulation = false;
		        } else {
		          this.sendPostulation = true;
		        }

		        if (this.sendPostulation == true) {
					this.enviarActivo = false;

		        	Swal.fire({
			            title: '¿Está seguro que desea enviar su postulación?',
			            //text: "You won't be able to revert this!",
			            icon: 'warning',
			            showCancelButton: true,
			            confirmButtonColor: '#28a745',
			            cancelButtonColor: '#757575',
			            confirmButtonText: 'Enviar postulación',
			            cancelButtonText: 'Cancelar',
						didDestroy: () => {
								window.scrollTo(0,0)
							}
			          }).then((result) => {
			            if (result.isConfirmed) {

						  this.saveContinueThirdStep();
						  if(!this.tieneCorreccion){
							  this.sendBigObject();
						  } else {
							  //console.log('se activo el metodo de eduardo');
							  this.activarCorreccion();
						  }
			            } else{
							this.enviarActivo = true;
						}
			          })
		        	
		        	
		        } else {
		        	Swal.fire({
		            icon: 'warning',
		            title: 'Debe completar el formulario para enviar su postulación.',
		            //text: 'El máximo de caracteres es 100.',
		            //footer: '<a href>Why do I have this issue?</a>'
		          })
		          //alert("Debe completar el formulario para enviar su postulación.");
		        }
		    },

			savePostThirdStep: function () {
			          
		        let thirdStepObject = this.completeObject;
		        let data = JSON.stringify(thirdStepObject);
		        //console.log("third step Object ready to be sent: " + data);
		      	//console.log("ThirdStep length: " + thirdStepObject.length);
		      	if (this.completeObject.length > 0) {
			        axios.post(this.URL + '/guardarParcial', data).then((response) => {
			          //console.log(response.data);
			        }).catch(function (error) {
			          //console.log("AXIOS ERROR: ", error);
			        });
		      	} else {
		      		Swal.fire({
			            icon: 'warning',
			            title: '¡Error al guardar, intente de nuevo!',
			            //text: 'El máximo de caracteres es 100.',
			            //footer: '<a href>Why do I have this issue?</a>'
			        })
		          //alert("¡Error al guardar, intente de nuevo!");
		        }
			},
			
			saveCorreccionPostThirdStep: function () {
			          
		        let thirdStepObject = this.completeObject;
		        let data = JSON.stringify(thirdStepObject);
		        //console.log("third step Object ready to be sent: " + data);
		      	//console.log("ThirdStep length: " + thirdStepObject.length);
		      	if (this.completeObject.length > 0) {
			        axios.post(this.URL + '/guardarParcialCorreccion', data).then((response) => {
			          //console.log(response.data);
			        }).catch(function (error) {
			          //console.log("AXIOS ERROR: ", error);
			        });
		      	} else {
		      		Swal.fire({
			            icon: 'warning',
			            title: '¡Error al guardar, intente de nuevo!',
			            //text: 'El máximo de caracteres es 100.',
			            //footer: '<a href>Why do I have this issue?</a>'
			        })
		          //alert("¡Error al guardar, intente de nuevo!");
		        }
	        },

			sendBigObject: function () { // colocamos los msj aqui
	          
		        let bigObject = this.completeObject[0].nroSolicitud;
		        //console.log(bigObject);
		        //let data = JSON.stringify(bigObject); 
				////console.log(this.URL + '/procesarCorreccion/');
		        axios.post(this.URL + '/guardarObjeto/' + bigObject).then((response) => {
		          //console.log(response);
		          let data = response.data;
		          this.success = data;
				  /* 
				  Mensajes  
				  cambios lucas 26/03/2021
				  para solucionar problema con envio de postulacion correcto pero da error 
				  */
					Swal.fire({
			                title: 'Cargando...',
			                allowEscapeKey: false,
			                allowOutsideClick: false,
			                showConfirmButton: false,
			                timer: 5000,
			                willOpen: () => {
			                  Swal.showLoading();
			                },
							didDestroy: () => {
								window.scrollTo(0,0)
							}
			              }).then((result) => {
							  
			                  if (this.success.code === 200) {
			                  	//console.log("code" + this.success.code);
			                  	
								  
			                  	if (result.dismiss === Swal.DismissReason.timer) {
				                    //console.log('closed by timer!!!!');
				                    Swal.fire({ 
				                      title: '¡Postulación enviada satisfactoriamente!',
				                      icon: 'success',
				                      text: this.success.message,
				                      timer: 4000,
				                      showConfirmButton: false,
									  didDestroy: () => {
										window.scrollTo(0,0)
									  }
				                    })
								  }
								  this.searchStatus();
				                  this.setSuccessStepValue(true);
				              	  this.setThirdStepValue(false);
									this.enviarActivo = true;
			                  } else if (this.success.code !== 200){
			                //   } else {
			                  	Swal.fire({
								  icon: 'error',
								  title: 'Error',
								  text: 'Se ha producido un error al procesar su solicitud. Favor intentar nuevamente. Será redirigido a la pantalla principal.',
								//   text: this.success.message,
								  didDestroy: () => {
										window.scrollTo(0,0)
									}
								})
								this.enviarActivo = true;
								
			                  }
			                  
			                }
			              )

		        }).catch(function (error) {
		          //console.log("AXIOS ERROR: ", error);
				  Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: 'Se ha producido un error al procesar su solicitud. Favor intentar nuevamente. Será redirigido a la pantalla principal.',
                    //   text: error, 
          			});
		        });
		    },

		    saveContinueThirdStep () {
				let otherSelectP1 = this.motivoSelectp1;
				let otherSelectP2 = this.motivoSelectp2;
				let otherSelectP3 = this.motivoSelectp3;

				if(otherSelectP2 == otherSelectP1){
				otherSelectP2 = "";
				};
				if(otherSelectP3 == otherSelectP1){
				otherSelectP3 = "";
				};
				if(otherSelectP2 == otherSelectP3){
				otherSelectP3 = "";
				};

				if(otherSelectP1 == "7"){
				otherSelectP1 = 7
				} else {
				this.other1 = "";
				};
				if(otherSelectP2 == "8"){
				otherSelectP2 = 7
				} else {
				this.other2 = "";
				};
				if(otherSelectP3 == "9"){
				otherSelectP3 = 7
				}else {
				this.other3 = "";
				};
		    	this.thirdStepObject.push({
		    		tabs: {
		    			tabs: this.tabCount,
			    		tab1: this.tab1,
			    		tab2: this.tab2,
			    		tab3: this.tab3,
			    		tab4: this.tab4,
		    		},
					motivationPriorityOne: {
						motID: otherSelectP1,
						priority: "1",
						other: this.other1
					},
					motivationPriorityTwo: {
						motID: otherSelectP2,
						priority: "2",
						other: this.other2
					},
					motivationPriorityThree: {
						motID: otherSelectP3,
						priority: "3",
						other: this.other3
					}
		    	});

		    	//console.log(this.thirdStepObject);
				this.saveCompletedFormPN([this.thirdStepObject, 3]);
				if(!this.tieneCorreccion){
					//console.log('Guardado Parcial');
					this.savePostThirdStep();
				} else {
					//console.log('Nuevo Metodo Correccion Guardado Parcial');
					this.saveCorreccionPostThirdStep();
				}
		        //console.log(this.completeObject);
		        this.thirdStepObject = [];
		    },

		    saveThirdStep() {

		    	Swal.fire({
			        title: '¿Está seguro que desea guardar su postulación?',
			        //text: "You won't be able to revert this!",
			        icon: 'warning',
			        showCancelButton: true,
			        confirmButtonColor: '#28a745',
			        cancelButtonColor: 'btn btn-danger',
			        confirmButtonText: 'Guardar',
			        cancelButtonText: 'Cancelar',
			    }).then((result) => {
			        if (result.isConfirmed) {
						let otherSelectP1 = this.motivoSelectp1;
						let otherSelectP2 = this.motivoSelectp2;
						let otherSelectP3 = this.motivoSelectp3;

						if(otherSelectP2 == otherSelectP1){
						otherSelectP2 = "";
						};
						if(otherSelectP3 == otherSelectP1){
						otherSelectP3 = "";
						};
						if(otherSelectP2 == otherSelectP3){
						otherSelectP3 = "";
						};

						if(otherSelectP1 == "7"){
						otherSelectP1 = 7
						} else {
						this.other1 = "";
						};
						if(otherSelectP2 == "8"){
						otherSelectP2 = 7
						} else {
						this.other2 = "";
						};
						if(otherSelectP3 == "9"){
						otherSelectP3 = 7
						}else {
						this.other3 = "";
						};
				    	this.thirdStepObject.push({
				    		tabs: {
				    			tabs: this.tabCount,
					    		tab1: this.tab1,
					    		tab2: this.tab2,
					    		tab3: this.tab3,
					    		tab4: this.tab4,
				    		},
							motivationPriorityOne: {
								motID: otherSelectP1,
								priority: "1",
								other: this.other1
							},
							motivationPriorityTwo: {
								motID: otherSelectP2,
								priority: "2",
								other: this.other2
							},
							motivationPriorityThree: {
								motID: otherSelectP3,
								priority: "3",
								other: this.other3
							}
				    	});

				    	//console.log(this.thirdStepObject);
				        this.saveCompletedFormPN([this.thirdStepObject, 3]);
				        this.savePostThirdStep();
				        //console.log(this.completeObject);
				        this.thirdStepObject = [];
						Swal.fire(
							'¡Datos guardados satisfactoriamente!',
							'',
							'success'
						)
			          
			        }
			    })
			},
			// dispara el metodo que consume la correccion
			activarCorreccion() {
				let bigObject = this.completeObject[0].nroSolicitud;
		        //console.log(bigObject);
		        
		        //let data = JSON.stringify(bigObject); 
		        axios.post(this.URL + '/procesarCorreccion/' + bigObject).then((response) => {
		          //console.log(response.data);
		          let data = response.data;
		          this.success = data;

				  /* 
				  Mensajes  
				  cambios lucas 26/03/2021
				  para solucionar problema con envio de postulacion correcto pero da error 
				  */
					Swal.fire({
			                title: 'Cargando...',
			                allowEscapeKey: false,
			                allowOutsideClick: false,
			                showConfirmButton: false,
			                timer: 5000,
			                willOpen: () => {
			                  Swal.showLoading();
			                },
							didDestroy: () => {
								window.scrollTo(0,0)
							}
			              }).then((result) => {
							  
			                  if (this.success.code === 200) {
			                  	//console.log("code" + this.success.code);
								  
			                  	if (result.dismiss === Swal.DismissReason.timer) {
				                    //console.log('closed by timer!!!!');
				                    Swal.fire({ 
				                      title: '¡Postulación enviada satisfactoriamente!',
				                      icon: 'success',
				                      text: this.success.message,
				                      timer: 4000,
				                      showConfirmButton: false,		  
										didDestroy: () => {
											window.scrollTo(0,0)
										}
				                    })
								  }
								  this.searchStatus();
				                  this.setSuccessStepValue(true);
				              	  this.setThirdStepValue(false);
									this.enviarActivo = true;
			                } else if (this.success.code !== 200){
			                  
			                  	Swal.fire({
								  icon: 'error',
								  title: 'Error',
								  text: 'Se ha producido un error al procesar su solicitud. Favor intentar nuevamente. Será redirigido a la pantalla principal.',
								//   text: this.success.message,
								  didDestroy: () => {
									window.scrollTo(0,0)
								  }
								})
								this.enviarActivo = true;
			                  }
			                }
			              )
		        }).catch(function (error) {
		          //console.log("AXIOS ERROR: ", error);
				  Swal.fire({
                      icon: 'error',
                      title: 'Error',
                      text: 'Se ha producido un error al procesar su solicitud. Favor intentar nuevamente. Será redirigido a la pantalla principal.',
                    //   text: error, 
         			 });
		        });
			},
			
			getRut() {
		      let routeNumber = this.$route.params.id;
		      let number;
		      let rut;
		      //console.log(routeNumber);
		      axios.get(this.URL + '/getRut/' + routeNumber).then((response) => {
		        let data = response.data;
		        // //console.log(data);
		        // //console.log(data[0].requestNumber);
		        // //console.log(data[0].rut);
		        number = data[0].requestNumber;
		        rut = data[0].rut;
		        if (routeNumber == number) {
		          //console.log("Match requestNumber");
		          this.rut = rut;
		          this.getNroSolicitud(this.rut);
		          //this.rutValidation(this.rut);
		        } else {
		        }
		        ////console.log(this.tipoSocDocs);
		      }).catch(function (error) {
		        //console.log("AXIOS ERROR: ", error);
		      });
			},
			
			validationStep(nroSolicitud){
				//console.log('Numero de SOLICITUD', nroSolicitud)
			
			axios.get(this.URL + '/validarCorreccion/' + nroSolicitud +'-5').then((response) => {
				let data = response.data;
				//console.log('Response Validar Correccion',data);
				// this.corregir = false;
				// this.tieneCorreccion = true
				if (data.ESTADO !== 'PENDIENTE A ENVÍO') {
					//CORREGIR_PASO viene true si se debe volver a ingresar informacion y false si no se debe corregir, es decir es valido
					this.corregir = data.CORREGIR_PASO;

					this.tieneCorreccion = true; // indica que tomara el camino de correccion
				}
		        
		      }).catch(function (error) {
		        //console.log("AXIOS ERROR: ", error);
		      });
			},

			 getNroSolicitud(rut) {
		    	axios.get(this.URL + '/buscarPostulante/' + rut).then((response) => {
		        this.datosBasicos = response.data;
		        //console.log(this.datosBasicos);
		        //console.log(this.datosBasicos[0].nro_solicitud);
		        this.requestNumberValue = this.datosBasicos[0].nro_solicitud;
		        //this.requestNumberObject(this.requestNumberValue);
				//console.log(this.requestNumberValue);
				this.validationStep(this.requestNumberValue);
		      setTimeout(this.getSecondStepRequest(this.requestNumberValue), 3000);
		    //   this.getRutGlobal(rut);
		      }).catch(function (error) {
		      //console.log("AXIOS ERROR: ", error);
		      });
			},
			
			getSecondStepRequest(number) {
		      //console.log(number)
		      let requestNumber = number;
		      axios.get(this.URL + '/paso1/' + requestNumber).then((response) => {
		        let firstStepSaved = response.data;
		        // //console.log(firstStepSaved);
		        // //console.log(firstStepSaved[0].object);
				this.getThirdStep = JSON.parse(firstStepSaved[0].object);
				const estado = JSON.parse(firstStepSaved[0].estado);
				const idConecta = JSON.parse(firstStepSaved[0].idConecta); // nueva modificacion al back
          		if ((estado === 1 && idConecta == null) || estado === 3) {
					// //console.log(this.getThirdStep);
	
					// TRAEMOS LA VARIABLE GLOBAL CON EL OBJETO ALMACENADO
					this.storeObjectThirdStep = this.$store.getters.getterObjetoThirdStep;
					// //console.log(this.$store.getters.getterObjetoThirdStep);
					// //console.log('STORE// objetoSecondtStep: ', this.storeObjectThirdStep);
					
					if(this.storeObjectThirdStep.length == 1) {
						//console.log('no entro');
						this.$store.commit('setObjetoThirdStep',this.getThirdStep);
						this.recoveryDataForm(this.getThirdStep);
					} else {
						//console.log('entro');
						this.recoveryDataForm(this.storeObjectThirdStep);
					}
					//this.recoveryDataForm()
				} 
				if (estado === 2 || estado === 0) {
					// SE PODRIA USAR PARA REDIRECCIONAR A HOME
					//console.log('Estado de solicitud Caducada o Inactiva');
				}
		      }).catch(function (error) {
		        //console.log("AXIOS ERROR: ", error);
		      });
			},
			
			recoveryDataForm(objectData) {
				const stepFive = objectData[3]

				if(stepFive){
					this.tabCount = stepFive.tabs.tabs
					// tab 1
						if ( stepFive.tabs.tab1 == 'form-tab tab01 active') {
							//  this.$store.commit('activeClass',this.$refs.tab1)
							this.$refs.tab1.className = stepFive.tabs.tab1
							this.$store.state.tab1 = stepFive.tabs.tab1
						}

						if ( stepFive.tabs.tab1 == 'form-tab tab01 success') {
							////console.log('tab1 succes',stepFive.tabs.tab1);
							this.$refs.tab1.className = stepFive.tabs.tab1
							this.$store.state.tab1 = stepFive.tabs.tab1
						}
						if (stepFive.tabs.tab1 == 'form-tab tab01') {
							this.$refs.tab1.className = stepFive.tabs.tab1
						}

						// tab 2
						if ( stepFive.tabs.tab2 == 'form-tab tab02 active') {
							//  this.$store.commit('activeClass',this.$refs.tab2)
							this.$refs.tab2.className = stepFive.tabs.tab2
							this.$store.state.tab2 = stepFive.tabs.tab2
						}

						if ( stepFive.tabs.tab2 == 'form-tab tab02 success') {
							this.$refs.tab2.className = stepFive.tabs.tab2
							this.$store.state.tab2 = stepFive.tabs.tab2
						}
						if (stepFive.tabs.tab2 == 'form-tab tab02') {
							this.$refs.tab2.className = stepFive.tabs.tab2
						}

						// tab 3
						if ( stepFive.tabs.tab3 == 'form-tab tab03 active') {
							//  this.$store.commit('activeClass',this.$refs.tab3)
							this.$refs.tab3.className = stepFive.tabs.tab3
							this.$store.state.tab3 = stepFive.tabs.tab3
						}

						if ( stepFive.tabs.tab3 == 'form-tab tab03 success') {
							this.$refs.tab3.className = stepFive.tabs.tab3
							this.$store.state.tab3 = stepFive.tabs.tab3
						}
						if (stepFive.tabs.tab3 == 'form-tab tab03') {
							this.$refs.tab3.className = stepFive.tabs.tab3
						}

						// tab 4
						if ( stepFive.tabs.tab4 == 'form-tab tab04 active') {
							//  this.$store.commit('activeClass',this.$refs.tab4)
							this.$refs.tab4.className = stepFive.tabs.tab4
							this.$store.state.tab4 = stepFive.tabs.tab4
							this.$store.state.tabInfo = 'tab-info height'
						}

						if ( stepFive.tabs.tab4 == 'form-tab tab04 success') {
							this.$refs.tab4.className = stepFive.tabs.tab4
							this.$store.state.tab4 = stepFive.tabs.tab4
						}
						if (stepFive.tabs.tab4 == 'form-tab tab04') {
							this.$refs.tab4.className = stepFive.tabs.tab4
						}	
						
						// tab 5
						if ( stepFive.tabs.tab5 == 'form-tab tab05 active') {
							// this.$store.commit('activeClass',this.$refs.tab5)
							this.$refs.tab5.className = stepFive.tabs.tab5
							this.$store.state.tab5 = stepFive.tabs.tab5
							this.$store.state.tabInfo = 'tab-info height2'
						}

						if ( stepFive.tabs.tab5 == 'form-tab tab05 success') {
							this.$refs.tab5.className = stepFive.tabs.tab5
							this.$store.state.tab5 = stepFive.tabs.tab5
						}
						
						if(stepFive.motivationPriorityOne.motID){
							this.$store.commit("setMotivationOne", stepFive.motivationPriorityOne.motID);
						};

						if(stepFive.motivationPriorityTwo.motID){
							if(stepFive.motivationPriorityOne.motID == 7){
								let PriorityTwo = 8;
								this.$store.commit("setMotivationTwo", PriorityTwo);
							} else {
								this.$store.commit("setMotivationTwo", stepFive.motivationPriorityTwo.motID);
							}
						}
						if(stepFive.motivationPriorityThree.motID){
							if(stepFive.motivationPriorityThree.motID == 7){
								let PriorityThree = 9;
								this.$store.commit("setMotivationThree", PriorityThree);
							} else {
								this.$store.commit("setMotivationThree", stepFive.motivationPriorityThree.motID);
							}
						}

						if(stepFive.motivationPriorityOne.other != ""){
							this.other1 = stepFive.motivationPriorityOne.other;
						}
						if(stepFive.motivationPriorityTwo.other != ""){
							this.other2 = stepFive.motivationPriorityTwo.other;
						}
						if(stepFive.motivationPriorityThree.other != ""){
							this.other3 = stepFive.motivationPriorityThree.other;
						}

				} else {
					//console.log('No existe recuperacion parcial para el SecondStep');
				}

			},

			// metodos para recuperar el estado de la solicitud
    		searchStatus(){
				//console.log('numero de solicitud',this.requestNumberValue);
				this.requestIdConecta(this.globalRequestNumber);
			},

    		requestIdConecta(requestNumber) {
				axios.get(this.URL + '/status/' + requestNumber).then((response) => {
			        let data = response.data;
			        //let test = JSON.parse(data);
			        //console.log(data[0].id_conecta);
			        //console.log("data: " + data);
			        let statusRequest;
			        for (const key in data) {
                //console.log("key", key);
                //console.log("value", data[key]);
                statusRequest = data[0];
					    }
			        ////console.log(status[0].object);
			        //this.statusRequest = JSON.parse(status[0].id_conecta);
			        let status = data[0].status;
			        //console.log(data[0].status);
			        //console.log(statusRequest);
			        // this.idRequest = statusRequest;
			        // this.process(this.idRequest);
			        this.process(statusRequest);
			      }).catch(function (error) {
			        //console.log("AXIOS ERROR: ", error);
			      });
      },
      
      process (idConecta) {
		      //console.log(idConecta.id_conecta);
		      axios.get(this.URL + '/stage/' + idConecta.id_conecta).then((response) => {
		        let stage = response.data;
		        //console.log('stage',stage);
				    //console.log('ESTADO SETEADO',stage[0].ID_ESTADO);
				    //console.log('ETAPA SETEADO',stage[0].ETAPA);
		        this.saveProcess(stage[0].ID_ESTADO, stage[0].ETAPA);
		      }).catch(function (error) {
		        //console.log("AXIOS ERROR: ", error);
		      });
      },
      
      saveProcess(idEstado, etapa){
	        	//console.log("idEstado: " + idEstado);
	        	//console.log("Etapa: " + etapa);
				if (idEstado == 3) {
					this.setFinalStatus("Postulación enviada");
				} else if (idEstado == 11) {
					this.setFinalStatus("Verificación de Antecedentes");
				} else if (idEstado == 12) {
					this.setFinalStatus("Verificación de Antecedentes");
				} else if (idEstado == 13) {
					this.setFinalStatus("Verificación de Antecedentes");
				} else if (idEstado == 5) {
					this.setFinalStatus("Evaluación de Comisión de Socios");
				} else if (idEstado == 9) {
					this.setFinalStatus("Revisión del Directorio");
				} else if (idEstado == 6) {
					this.setFinalStatus("El Área Socios se contactará telefónicamente con usted");
				} else if (idEstado == 8) {
					this.setFinalStatus("Corrección");
				} else if (idEstado == 10) {
					this.setFinalStatus("Postulación pendiente");
				} else if (idEstado == 7) {
					this.setFinalStatus("Verificación de Antecedentes");
				}

				if (idEstado == 3) {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item checkSecond')
			        this.setCheck3('c-steps-numbers__item checkThird')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			    }
			      if (idEstado == 11) {
			        this.setCheck2("c-steps-numbers__item yellow");
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck3('c-steps-numbers__item checkThird')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if ((idEstado == 5) || (idEstado == 6 && etapa == 'COMISION DE SOCIOS')
			        || (idEstado == 8 && etapa == 'COMISION DE SOCIOS')) {
			        //console.log("Soy blue");
			        this.setCheck3("c-steps-numbers__item blue");
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if ((idEstado == 9) || (idEstado == 6 && etapa == 'DIRECTORIO NACIONAL')) {
			        this.setCheck4("c-steps-numbers__item green");
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item blue');
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      /*if (idEstado == 9) {
			        this.setCheck5("c-steps-numbers__item purple");
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item blue');
			        this.setCheck4("c-steps-numbers__item green");
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }*/
			      if (idEstado == 9 && idEstado == 1) {
			        this.setCheck6('c-steps-numbers__item lightorange')
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item blue');
			        this.setCheck4("c-steps-numbers__item green");
			        this.setCheck5('c-steps-numbers__item purple')
			      }
			      if (idEstado == 10) {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item checkThird')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if (idEstado == 7) {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item checkThird')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if (idEstado == 12) {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item checkThird')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if (idEstado == 13) {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item blue')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if ((idEstado == 6 && etapa == 'VALIDACION') 
			      		|| (idEstado == 6 && etapa == 'PRE-ADMISIBILIDAD') 
			      		|| (idEstado == 6 && etapa == 'ADMISIBILIDAD')) {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item checkThird')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if (idEstado == 6 && etapa == 'COMISION DE SOCIOS') {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item blue')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if (idEstado == 6 && etapa == 'DIRECTORIO NACIONAL') {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item blue')
			        this.setCheck4('c-steps-numbers__item green')
			        this.setCheck5('c-steps-numbers__item purple')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if ((idEstado == 8 && etapa == 'VALIDACION') 
			      		|| (idEstado == 8 && etapa == 'PRE-ADMISIBILIDAD') 
			      		|| (idEstado == 8 && etapa == 'ADMISIBILIDAD')) {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item checkThird')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
			      if (idEstado == 8 && etapa == 'COMISION DE SOCIOS') {
			        this.setCheck1("c-steps-numbers__item orange");
			        this.setCheck2('c-steps-numbers__item yellow')
			        this.setCheck3('c-steps-numbers__item blue')
			        this.setCheck4('c-steps-numbers__item checkFourth')
			        this.setCheck5('c-steps-numbers__item checkFifth')
			        this.setCheck6('c-steps-numbers__item checkSixth')
			      }
	  
  			},
		},

		computed: {
	      ...mapState([
	        "collapse",
	        "completeObject",
	        "tab1",
	        "tab2",
	        "tab3",
	        "tab4",
	        "tab5",
	        "tabInfo",
	        "URL",
	        "globalRequestNumber",
	        "rutGlobal",
			"showSuccessStep",
            "nroSolicitudGlobal",
            "finalStatus",
			"check1",
		    "check2",
		    "check3",
		    "check4",
		    "check5",
			"check6",
			"motivos",
        	"motivoSelectp1",
        	"motivoSelectp2",
        	"motivoSelectp3"
	      ]),
		},
		
		created(){
			this.getRut(),
			this.getMotivos();
		},
	}
</script>
<style>
	.height {
		max-height: 50px !important;
	}
	.height2 {
		max-height: 2500px !important;
	}

	*:focus {
	  outline: white;
	}
</style>